import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3da0ea04"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "請求書の管理", -1))
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 未処理を全て選択 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 送付済を全て選択 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 選択を解除 ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "noMargin" }, "選択した請求に対する操作", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("請求書を作成")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("入金済にする")
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!
  const _component_n_skeleton = _resolveComponent("n-skeleton")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_checkbox = _resolveComponent("n-checkbox")!
  const _component_n_badge = _resolveComponent("n-badge")!
  const _component_n_checkbox_group = _resolveComponent("n-checkbox-group")!
  const _component_n_empty = _resolveComponent("n-empty")!
  const _component_n_layout = _resolveComponent("n-layout")!

  return (_openBlock(), _createBlock(_component_n_space, {
    vertical: "",
    style: {"padding":"10px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_layout, { style: {"padding":"10px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_Menu),
          _hoisted_1,
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_n_space, {
                key: 0,
                vertical: "",
                style: {"background-color":"white","padding":"10px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_skeleton, {
                    height: "1rem",
                    width: "66%",
                    sharp: false
                  }),
                  _createVNode(_component_n_skeleton, {
                    height: "1rem",
                    width: "66%",
                    sharp: false
                  }),
                  _createVNode(_component_n_skeleton, {
                    height: "1rem",
                    width: "66%",
                    sharp: false
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.invoices.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_n_button, {
                  quaternary: "",
                  type: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectAll('wait'))),
                  disabled: !_ctx.invoices.length,
                  class: "btn"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_n_button, {
                  quaternary: "",
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectAll('sent'))),
                  disabled: !_ctx.invoices.length,
                  class: "btn"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_n_button, {
                  quaternary: "",
                  type: "primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectAll('unselect'))),
                  disabled: !_ctx.invoices.length,
                  class: "btn"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _hoisted_6,
                _createVNode(_component_n_button, {
                  type: "primary",
                  onClick: _ctx.getInvoice,
                  disabled: !_ctx.useInvoice.length,
                  class: "btn"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]),
                _createVNode(_component_n_button, {
                  type: "primary",
                  onClick: _ctx.markAsPaid,
                  disabled: !_ctx.useInvoice.length,
                  class: "btn"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]),
                _createVNode(_component_n_checkbox_group, {
                  value: _ctx.useInvoice,
                  "onUpdate:value": [
                    _cache[3] || (_cache[3] = ($event: any) => ((_ctx.useInvoice) = $event)),
                    _ctx.handleUseInvoice
                  ]
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoices, (a) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "horizontal",
                        key: a.num
                      }, [
                        _createVNode(_component_n_checkbox, {
                          value: a.num,
                          label: " ",
                          disabled: a.status === 'paid'
                        }, null, 8, ["value", "disabled"]),
                        _createElementVNode("div", _hoisted_9, "期日: " + _toDisplayString(_ctx.handleUnix(a.dueAt)), 1),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.handlePaidFor(a.paidFor)), 1),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(a.price.toLocaleString()) + "円", 1),
                        _createVNode(_component_n_badge, {
                          value: _ctx.label(a.status),
                          color: _ctx.labelColor(a.status),
                          class: "badge"
                        }, null, 8, ["value", "color"])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "onUpdate:value"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_n_empty, { description: "請求書はありません" })
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}